<template>
  <div
    class="hcl-toolbar-content-header"
    :class="wrapperCss"
  >
    <div class="toolbar-content-header-header">
      <i
        v-if="iconClass"
        :class="iconClass"
      ></i>
      {{ props.definition.text }}
    </div>
    <div
      class="toolbar-content-header-subheader"
      v-if="rangeSubHeader.show"
      :class="props.definition.subheader?.css"
    >
      <i
        v-if="props.definition.subheader?.icon !== ''"
        :class="props.definition.subheader?.icon"
      ></i>
      <span>
        {{ rangeSubHeader.msg }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'

import { useDataStore } from '@/stores/data'

import { DefinitionToolbarContentHeader } from '@/components/types'

interface Props {
  /**
   * Definition as an JS object.
   */
  definition: DefinitionToolbarContentHeader
}

const props = withDefaults(defineProps<Props>(), {
  definition: undefined
})

const toolbarMetaId = inject('toolbarMetaId', '')

const { link } = useDataStore()

const bucketToolbar = link(toolbarMetaId)

const iconClass = computed(() => {
  return props.definition.icon ?? undefined
})

const wrapperCss = computed(() => {
  let css = props.definition.css ?? ''

  if ((props.definition.variant ?? undefined) === 'bold') {
    css = css?.length ? css += ' content-variant-bold' : 'content-variant-bold'
  }

  return css
})

const rangeSubHeader = computed(() => {
  if (props.definition.subheader === undefined) return {}
  if (props.definition.subheader.type !== 'range') return {}

  let data: any

  const v = props.definition.subheader.criterium
  if (v.includes('.')) {
    let d = bucketToolbar.value
    for (const element of v.split('.')) {
      try {
        d = d[element]
      } catch (e) {
        /* tslint:disable:no-empty */
      }
    }
    data = d
  }

  if (data === undefined) return {}

  const template =
    parseInt(data) === 1 ? props.definition.subheader.singular : props.definition.subheader.plural

  const msg = template.replace('{{ ' + props.definition.subheader.criterium + ' }}', data)

  return {
    show: data !== undefined,
    msg: msg
  }
})
</script>

<style lang="scss" scoped>
.hcl-toolbar-content-header {
  margin: 0;
  display: flex;
  flex-direction: row;
  align-items: center;

  .content-variant-bold {
    font-size: 16px;
    font-weight: 600;
  }

  .toolbar-content-header-header {
    display: flex;
    align-items: baseline;
    margin: 0;

    i {
      margin-right: 0.25rem;
    }
  }

  .toolbar-content-header-subheader {
    margin: auto;
    padding-left: 1rem;
    white-space: nowrap;

    i {
      margin-right: 0.25rem;
    }

    &.h4 {
      i[class*='eii--']:not([class*=eii--stack]) {
        top: 0.125rem;
      }
    }
  }
}
</style>
